import { render } from "./vproductclass.vue?vue&type=template&id=63ff117a&scoped=true"
import script from "./vproductclass.vue?vue&type=script&lang=js"
export * from "./vproductclass.vue?vue&type=script&lang=js"

import "./vproductclass.vue?vue&type=style&index=0&id=63ff117a&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63ff117a"]])

export default __exports__